module.exports = __webpack_public_path__ + "img/tutorial_results-document.f6277fb3.png";